import { Button } from "primereact/button";
import { useState } from "react";

import { StyledAmountLabel, StyledInputNumber } from "../styled";

interface IPaymentAmountProps {
  id: string;
  value: number;
  editable?: boolean;
  max?: number;
  className?: string;
  onValueChange?: any;
  title: string;
}

export function PaymentAmount({
  id,
  value,
  editable,
  max,
  className,
  onValueChange,
  title,
}: IPaymentAmountProps) {
  return (
    <div className={`flex flex-column ${className}`}>
      <StyledAmountLabel>{title}</StyledAmountLabel>
      <div className="flex w-full align-items-center gap-2">
        <StyledInputNumber
          id={id}
          value={value}
          mode="currency"
          currency="USD"
          locale="en-US"
          disabled={!editable}
          min={1}
          max={max}
          onValueChange={onValueChange}
        />
      </div>
    </div>
  );
}
